import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Translator } from "@sharedV11/services/translator/translator.service";

@Component({
  selector: "app-input-filter",
  templateUrl: "./input-filter.component.html",
  styleUrls: ["./input-filter.component.scss"],
})
export class InputFilterComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild("inputFiltro") inputFiltroRef: ElementRef<HTMLInputElement>;

  /** 2.º clique no campo com lista aberta: fechar datalist (blur). */
  private suppressFirstMouseDownClose = false;
  private lastTabNavigationTime = 0;
  private lastInputFocusTimeStamp = 0;
  private lastInputFocusTimeStampIsDom = false;

  @Input() formControlText: any;
  @Input() placeHolderTranslation: string;
  @Input() label: string;
  @Input() list: any[] = [];
  // text show in input
  @Input() textShow: any;
  //data input
  @Input() dataInput: any;
  //API data
  @Input() data: any;
  @Input() required: any;
  @Input() disabled: any;
  
  @Input() autoValidate: boolean = true;

  @Input() validateTrigger: number | boolean = 0;
  /** Incrementar para forçar sincronização do texto visível com `data` (ex.: descartar cambios no pai). */
  @Input() uiSyncKey = 0;
  /** Latch do pai após submit inválido (ex.: Nombre Producto no Item Venta TX). */
  @Input() parentSubmitRequiredLatch: any = false;
  @Input() suppressParentSubmitLatch: any = false;
  @Input() selectOnly = false;
  @HostBinding("class.input-filter--select-only")
  get selectOnlyHostClass(): boolean {
    return this.selectOnly;
  }

  @Output() close = new EventEmitter();
  @Output() selected = new EventEmitter();
  @Output() getMethods = new EventEmitter();
  @Output() emitTextValueWithValue = new EventEmitter();

  listCopy: any[];
  idList;
  editorRegistroForm: FormGroup;

  intervalId;
  translation: any;

  constructor(
    private formBuilder: FormBuilder,
    private _cds: ChangeDetectorRef,
    private translator: Translator,
  ) {}

  @HostListener("document:keydown", ["$event"])
  private onDocumentKeydown(e: KeyboardEvent): void {
    if (e.key === "Tab") {
      this.lastTabNavigationTime = Date.now();
    }
  }

  private domEventTime(e: UIEvent): { t: number; isDom: boolean } {
    const dom = typeof e.timeStamp === "number" && e.timeStamp > 0;
    return { t: dom ? e.timeStamp : Date.now(), isDom: dom };
  }

  onInputFocus(event: FocusEvent): void {
    const input = this.inputFiltroRef?.nativeElement;
    if (!input || event.target !== input) {
      return;
    }
    const ft = this.domEventTime(event);
    this.lastInputFocusTimeStamp = ft.t;
    this.lastInputFocusTimeStampIsDom = ft.isDom;
    if (Date.now() - this.lastTabNavigationTime < 120) {
      this.suppressFirstMouseDownClose = true;
    }
  }

  onInputBlur(): void {
    this.suppressFirstMouseDownClose = false;
    this.lastInputFocusTimeStamp = 0;
    this.lastInputFocusTimeStampIsDom = false;
    this.closeInput();
  }

  onInputMouseDown(event: MouseEvent): void {
    if (!this.listCopy?.length || this.disabled) {
      return;
    }
    const input = this.inputFiltroRef?.nativeElement;
    if (!input) {
      return;
    }
    if (document.activeElement !== input) {
      return;
    }
    if (this.suppressFirstMouseDownClose) {
      this.suppressFirstMouseDownClose = false;
      return;
    }
    const mt = this.domEventTime(event);
    if (
      this.lastInputFocusTimeStampIsDom &&
      mt.isDom &&
      Math.abs(mt.t - this.lastInputFocusTimeStamp) < 120
    ) {
      return;
    }
  
    event.preventDefault();
    event.stopPropagation();
    input.blur();
  }

  ngAfterViewInit() {
    this.showData();
    this.controlErrors();
  }
  
  async ngOnInit() {
    this.translation = this.translator.GetTranslations();
    this.initlist();
  }

ngOnChanges(changes: SimpleChanges) {
  if (changes["disabled"] && this.editorRegistroForm) {
    const ac = this.editorRegistroForm.get("answer");
    if (ac) {
      if (this.disabled === true || this.disabled === "true") {
        ac.disable({ emitEvent: false });
      } else {
        ac.enable({ emitEvent: false });
      }
      ac.updateValueAndValidity({ emitEvent: false });
    }
  }

  if (!this.editorRegistroForm) return;

  if (changes["list"] && !changes["list"].firstChange) {
    this.initlist(changes["list"].currentValue);
    setTimeout(() => this.showData(), 0);
  }

  if (changes["data"] && !changes["data"].firstChange) {
    const next = changes["data"].currentValue;
    const shouldClear =
      next === null ||
      next === undefined ||
      next === "" ||
      next === "-1" ||
      next === 0 ||
      next === "0";

    if (shouldClear) {
      this.data = next;
      this.editorRegistroForm.controls["answer"].setValue("");
      this.editorRegistroForm.controls["answerHidden"].setValue(
        next === "-1" ? "-1" : ""
      );
      this._cds.detectChanges();
    } else {
      setTimeout(() => this.showData(), 0);
    }
  }
    

    if (changes["autoValidate"] && !changes["autoValidate"].firstChange) {
      if (this.editorRegistroForm) {
        this.controlErrors();
      }
    }
    if (changes["uiSyncKey"] && !changes["uiSyncKey"].firstChange) {
      setTimeout(() => this.showData(), 0);
    }
    if (changes['required'] && this.editorRegistroForm) {
      const answerCtrl = this.editorRegistroForm.get('answer');
      if (answerCtrl) {
        const hasRequired = this.required === 'true' || this.required === true;
        answerCtrl.setValidators(hasRequired ? [Validators.required] : []);
        answerCtrl.updateValueAndValidity({ emitEvent: false });
      }
    }

    if (
      this.editorRegistroForm &&
      (changes["parentSubmitRequiredLatch"] || changes["suppressParentSubmitLatch"])
    ) {
      const latched =
        this.parentSubmitRequiredLatch === true ||
        this.parentSubmitRequiredLatch === "true";
      const suppressed =
        this.suppressParentSubmitLatch === true ||
        this.suppressParentSubmitLatch === "true";
      if (latched && !suppressed) {
        setTimeout(() => this.reapplySubmitValidationVisual(), 0);
      }
    }

    if (changes["validateTrigger"] && this.editorRegistroForm) {
      const ch = changes["validateTrigger"];
      const curr = ch.currentValue;
      const prev = ch.previousValue;
      let fire = false;
      if (!ch.firstChange) {
        if (typeof curr === "number") {
          const p = typeof prev === "number" ? prev : 0;
          if (curr > p) {
            fire = true;
          }
        } else if (curr === true && prev !== true) {
          fire = true;
        }
      } else if (typeof curr === "number" && curr > 0) {
        fire = true;
      }
      if (fire) {
        setTimeout(() => this.reapplySubmitValidationVisual(), 1);
      }
    }
  }

  /** Tras Guardar com erro: habilitar answer si aplica, marcar touched y validar (evita carrera con showData). */
  reapplySubmitValidationVisual(): void {
    if (!this.editorRegistroForm) {
      return;
    }
    const disabledNow = this.disabled === true || this.disabled === "true";
    const answerCtrl = this.editorRegistroForm.get("answer");
    if (!disabledNow) {
      answerCtrl?.enable({ emitEvent: false });
    }
    this.editorRegistroForm.markAllAsTouched();
    this.editorRegistroForm.updateValueAndValidity({ emitEvent: false });
    this._cds.detectChanges();
  }

  OnChange() {
    if (this.listCopy && this.listCopy.length > 0) {
      const inputEl = document.getElementById(this.formControlText) as HTMLInputElement;
      const valName = inputEl?.value ?? "";
      //let val= (<HTMLInputElement>document.getElementById(this.formControlText+"-hidden")).value
      let val = this.editorRegistroForm.get("answerHidden").value;
      let find = this.listCopy.find(
        (row) =>
          this.normalizeInputFilterLabel(row[this.textShow]) ===
          this.normalizeInputFilterLabel(valName)
      );

      if (!find) {
        if (valName.length) {
          if (this.formControlText === "CustomerId") {
            const trimmed = valName.trim();
            const row = this.findRowByStoredValue(trimmed);
            if (row != null && row[this.dataInput] != null) {
              this.editorRegistroForm.controls["answer"].setValue(String(row[this.textShow]));
              this.editorRegistroForm.controls["answerHidden"].setValue(String(row[this.dataInput]));
            } else {
              const stripped = this.stripCompositeIdLabel(trimmed);
              const row2 =
                stripped !== trimmed ? this.findRowByStoredValue(stripped) : undefined;
              if (row2 != null && row2[this.dataInput] != null) {
                this.editorRegistroForm.controls["answer"].setValue(String(row2[this.textShow]));
                this.editorRegistroForm.controls["answerHidden"].setValue(String(row2[this.dataInput]));
              } else if (stripped !== trimmed) {
                this.editorRegistroForm.controls["answer"].setValue(trimmed.substring(0, 50));
                this.editorRegistroForm.controls["answerHidden"].setValue(
                  this.listCopy.length > 0 ? "" : stripped.substring(0, 50)
                );
              } else {
                const v = trimmed.substring(0, 50);
                this.editorRegistroForm.controls["answer"].setValue(v);
                this.editorRegistroForm.controls["answerHidden"].setValue(v);
              }
            }
          } else {
            this.editorRegistroForm.controls["answerHidden"].setValue("-1");
          }
        } else {
          this.editorRegistroForm.controls["answerHidden"].setValue("");
        }
        this.editorRegistroForm.controls["answer"].setErrors(null);
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.get("answerHidden").setValue(valueFind);
        this.editorRegistroForm.controls["answer"].setErrors(null);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.editorRegistroForm.get("answer")?.updateValueAndValidity({ emitEvent: false });

      this.emitTextValueWithValue.emit({
        name: valName,
        value: val,
        controlName: this.formControlText,
      });
      if (find || valName.length === 0) {
        this.selected.emit({
          name: this.formControlText,
          value: val,
          methods: this.callbackMethods(),
        });
      }
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.editorRegistroForm.get("answer")?.updateValueAndValidity({ emitEvent: false });
      this.selected.emit({
        name: this.formControlText,
        value: "-1",
        methods: this.callbackMethods(),
      });
    }
  }

  initlist(list?) {
    if (list !== undefined) {
      this.list = list;
    }
    this.listCopy = Array.isArray(this.list) ? [...this.list] : [];
    this.idList = this.formControlText + "-list";
    /* Só criar o FormGroup na 1.ª vez: ao refrescar o datalist, recriar apagava touched/dirty
       e o * Campo requerido piscava ou sumia (ex.: GetTipoEntrada após Guardar). */
    if (!this.editorRegistroForm) {
      this.generateForm();
    }
  }

  controlErrors() {
    if (this.autoValidate) {

      this.editorRegistroForm.updateValueAndValidity({ emitEvent: false });
    }
    this._cds.detectChanges();
  }

  callbackMethods() {
    return {
      markFormAsInvalid: this.markFormAsInvalid.bind(this),
      manualOnchange: this.OnChange.bind(this),
      setManualValueForm: this.setManualValueForm.bind(this),
      showData: this.showData.bind(this),
      toggleActiveForm: this.toggleActiveForm.bind(this),
      getAnswerVisibleForSync: this.getAnswerVisibleForSync.bind(this),
    }
  }

  markFormAsInvalid(control: string, errors: any) {
    this.editorRegistroForm.controls[control].setErrors(errors);
  }

  toggleActiveForm(active = true) {
    if (active) {
      this.editorRegistroForm.enable();
    } else {
      this.editorRegistroForm.disable();
    }
    this.disabled = !active;
  }

  /** Misma normalización en comparaciones de etiqueta (evita fallos por espacios múltiples). */
  private normalizeInputFilterLabel(s: any): string {
    return (s ?? "").toString().trim().replace(/  +/g, " ");
  }

  getSyncValueForParentForm(): string {
    if (!this.editorRegistroForm) {
      return "";
    }
    const hiddenRaw = this.editorRegistroForm.get("answerHidden")?.value;
    const visibleRaw = this.editorRegistroForm.get("answer")?.value;
    const hidden = (hiddenRaw != null ? String(hiddenRaw) : "").trim();
    const visible = (visibleRaw != null ? String(visibleRaw) : "").trim();

    if (this.formControlText === "CustomerId") {
      const maxLen = 50;
      const listLoaded = (this.listCopy?.length ?? 0) > 0;

      const resolveToListId = (candidate: string): string => {
        if (candidate === "" || candidate === "-1") {
          return "";
        }
        const row1 = this.findRowByStoredValue(candidate);
        if (row1 != null && row1[this.dataInput] != null) {
          return String(row1[this.dataInput]).trim().substring(0, maxLen);
        }
        const stripped = this.stripCompositeIdLabel(candidate);
        if (stripped !== candidate) {
          const row2 = this.findRowByStoredValue(stripped);
          if (row2 != null && row2[this.dataInput] != null) {
            return String(row2[this.dataInput]).trim().substring(0, maxLen);
          }
        }
        if (listLoaded) {
          return "";
        }
        if (stripped !== candidate) {
          return stripped.substring(0, maxLen);
        }
        return candidate.substring(0, maxLen);
      };

      if (hidden !== "" && hidden !== "-1") {
        return resolveToListId(hidden);
      }
      if (visible !== "") {
        return resolveToListId(visible);
      }
      return "";
    }

    if (hidden !== "" && hidden !== "-1") {
      return hidden;
    }

    if (visible !== "" && this.listCopy?.length) {
      const row = this.listCopy.find(
        (item) =>
          this.normalizeInputFilterLabel(item[this.textShow]) ===
          this.normalizeInputFilterLabel(visible)
      );
      if (row != null && row[this.dataInput] != null) {
        const id = String(row[this.dataInput]).trim();
        if (id !== "" && id !== "-1") {
          return id;
        }
      }
    }

    return "";
  }

  /** Texto visible del input (para que el padre resuelva pkId si el hidden quedó vacío o en -1). */
  getAnswerVisibleForSync(): string {
    if (!this.editorRegistroForm) {
      return "";
    }
    const v = this.editorRegistroForm.get("answer")?.value;
    return v != null ? String(v).trim() : "";
  }

  /** Parte antes de ` / ` em `Nombre`; só para localizar `row.Id` em DatosListas, não como valor final no API. */
  private stripCompositeIdLabel(raw: string): string {
    const s = String(raw ?? "").trim();
    const i = s.indexOf(" / ");
    return i > 0 ? s.substring(0, i).trim() : s;
  }

  private findRowByStoredValue(raw: any): any | undefined {
    if (raw === null || raw === undefined || raw === "") {
      return undefined;
    }
    const norm = (s: string) => s.trim().replace(/  +/g, " ");
    const dataValue = norm(String(raw));
    const key = this.dataInput;
    const labelKey = this.textShow;
    return this.listCopy.find((row) => {
      const v = row?.[key];
      const id = row?.Id;
      const pk = row?.pkId;
      const label = row?.[labelKey];
      return (
        (v != null && norm(String(v)) === dataValue) ||
        (id != null && norm(String(id)) === dataValue) ||
        (pk != null && norm(String(pk)) === dataValue) ||
        (label != null && norm(String(label)) === dataValue)
      );
    });
  }

  /** Solo `closeInput` (blur). En `OnChange` bloquearía el borrado manual en filtros datalist. */
  private applyValueWhenLabelMatchFails(
    valName: string,
    hiddenBefore: any
  ): void {
    const trimmedName = (valName ?? "").toString().trim().replace(/  /g, " ");
    const hiddenStr = (hiddenBefore != null ? String(hiddenBefore) : "").trim();

    const rowByStored =
      hiddenStr && hiddenStr !== "-1"
        ? this.findRowByStoredValue(hiddenStr)
        : undefined;

    if (rowByStored) {
      const label = rowByStored[this.textShow];
      if (label != null && String(label).trim() !== "") {
        this.editorRegistroForm.controls["answer"].setValue(String(label));
      }
      const idVal = rowByStored[this.dataInput];
      this.editorRegistroForm.controls["answerHidden"].setValue(
        idVal != null ? String(idVal) : hiddenStr
      );
      return;
    }

    if (this.formControlText === "CustomerId" && trimmedName.length > 0) {
      const row = this.findRowByStoredValue(trimmedName);
      if (row != null && row[this.dataInput] != null) {
        this.editorRegistroForm.controls["answer"].setValue(String(row[this.textShow]));
        this.editorRegistroForm.controls["answerHidden"].setValue(String(row[this.dataInput]));
        return;
      }
      const stripped = this.stripCompositeIdLabel(trimmedName);
      if (stripped !== trimmedName) {
        const row2 = this.findRowByStoredValue(stripped);
        if (row2 != null && row2[this.dataInput] != null) {
          this.editorRegistroForm.controls["answer"].setValue(String(row2[this.textShow]));
          this.editorRegistroForm.controls["answerHidden"].setValue(String(row2[this.dataInput]));
          return;
        }
        this.editorRegistroForm.controls["answer"].setValue(trimmedName);
        this.editorRegistroForm.controls["answerHidden"].setValue(
          this.listCopy.length > 0 ? "" : stripped.substring(0, 50)
        );
        return;
      }
      const v = trimmedName.substring(0, 50);
      this.editorRegistroForm.controls["answer"].setValue(v);
      this.editorRegistroForm.controls["answerHidden"].setValue(v);
      return;
    }

    if (trimmedName.length > 0) {
      this.editorRegistroForm.controls["answerHidden"].setValue("-1");
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
    }
  }

  /** Alineado con `ngOnChanges` de `data`: vaciar vista cuando el padre resetea el control. */
  private isDataEmptyForView(value: unknown): boolean {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "-1" ||
      value === 0 ||
      value === "0"
    );
  }

  showData() {
    if (!this.editorRegistroForm) {
      return;
    }
    const answerCtrl = this.editorRegistroForm.get("answer");
    if (this.disabled) {
      answerCtrl?.disable({ emitEvent: false });
    } else {
      answerCtrl?.enable({ emitEvent: false });
    }

    if (this.isDataEmptyForView(this.data)) {
      this.editorRegistroForm.controls["answer"].setValue("");
      this.editorRegistroForm.controls["answerHidden"].setValue(
        this.data === "-1" ? "-1" : ""
      );
      this._cds.detectChanges();
      return;
    }

    if (this.listCopy && this.listCopy.length > 0) {
      const dataValue = String(this.data);
      const row = this.findRowByStoredValue(this.data);
      if (row) {
        const label = row[this.textShow];
        const display =
          label != null && String(label).trim() !== ""
            ? String(label)
            : dataValue;
        this.editorRegistroForm.controls["answer"].setValue(display);
        const idVal = row[this.dataInput];
        this.editorRegistroForm.controls["answerHidden"].setValue(
          idVal != null ? String(idVal) : dataValue
        );
      } else {
        /* Valor persistido fora da lista: mostrar o código ao utilizador */
        let rowByPrefix: any;
        if (this.formControlText === "CustomerId") {
          const prefix = this.stripCompositeIdLabel(dataValue);
          if (prefix !== dataValue) {
            rowByPrefix = this.findRowByStoredValue(prefix);
          }
        }
        if (rowByPrefix != null && rowByPrefix[this.dataInput] != null) {
          const label = rowByPrefix[this.textShow];
          const display =
            label != null && String(label).trim() !== ""
              ? String(label)
              : dataValue;
          this.editorRegistroForm.controls["answer"].setValue(display);
          this.editorRegistroForm.controls["answerHidden"].setValue(
            String(rowByPrefix[this.dataInput])
          );
        } else {
          this.editorRegistroForm.controls["answer"].setValue(dataValue);
          const hiddenVal =
            this.formControlText === "CustomerId"
              ? this.listCopy.length > 0
                ? ""
                : this.stripCompositeIdLabel(dataValue)
              : dataValue;
          this.editorRegistroForm.controls["answerHidden"].setValue(hiddenVal);
        }
      }
    }
    this._cds.detectChanges();
  }

  setManualValueForm(value) {
    let display = value != null && value !== "" ? String(value) : "";
    let hiddenVal = display;

    if (value !== null && value !== undefined && value !== "") {
      const find = this.findRowByStoredValue(value);
      if (find) {
        const label = find[this.textShow];
        if (label != null && String(label).trim() !== "") {
          display = String(label);
        }
        const idVal = find[this.dataInput];
        hiddenVal = idVal != null ? String(idVal) : String(value);
      } else if (this.formControlText === "CustomerId") {
        const str = String(value).trim();
        const stripped = this.stripCompositeIdLabel(str);
        if (stripped !== str) {
          const row2 = this.findRowByStoredValue(stripped);
          if (row2) {
            const label = row2[this.textShow];
            if (label != null && String(label).trim() !== "") {
              display = String(label);
            }
            const idVal = row2[this.dataInput];
            hiddenVal = idVal != null ? String(idVal) : stripped;
          } else {
            display = str;
            hiddenVal = (this.listCopy?.length ?? 0) > 0 ? "" : stripped;
          }
        }
      }
    }
    this.data = hiddenVal;
    this.editorRegistroForm.controls["answer"].setValue(display);
    this.editorRegistroForm.controls["answerHidden"].setValue(hiddenVal);
  }

  generateForm() {
    const isRequired = this.required === true || this.required === "true";
    this.editorRegistroForm = this.formBuilder.group({
      answer: [
        { value: "", disabled: this.disabled },
        isRequired ? [Validators.required] : [],
      ],
      // answer:["",[Validators.required]],
      answerHidden: [""],
    });

    this.getMethods.emit({ methods: this.callbackMethods() });
  }

  intervaloClose() {
    /* if(this.interval){
      clearInterval(this.interval)
    } */
    let thisobj = this;

    setTimeout(function () {
      thisobj.closeInput();
    }, 1000);
    //clearInterval(this.intervalId)
  }
  closeInput() {
    clearInterval(this.intervalId)
    if (this.listCopy && this.listCopy.length > 0) {
      const inputEl = document.getElementById(this.formControlText) as HTMLInputElement;
      const valName = inputEl?.value ?? "";
      //let val= (<HTMLInputElement>document.getElementById(this.formControlText+"-hidden")).value
      let val = this.editorRegistroForm.get("answerHidden").value;
      let find = this.listCopy.find(
        (row) =>
          this.normalizeInputFilterLabel(row[this.textShow]) ===
          this.normalizeInputFilterLabel(valName)
      );

      if (!find) {
        this.applyValueWhenLabelMatchFails(valName, val);
        this.editorRegistroForm.controls["answer"].setErrors(null);
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.get("answerHidden").setValue(valueFind);
        this.editorRegistroForm.controls["answer"].setErrors(null);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.editorRegistroForm.get("answer")?.updateValueAndValidity({ emitEvent: false });

      this.emitTextValueWithValue.emit({
        name: valName,
        value: val,
        controlName: this.formControlText,
      });
      this.close.emit({ name: this.formControlText, value: val, methods: this.callbackMethods() });
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.editorRegistroForm.get("answer")?.updateValueAndValidity({ emitEvent: false });
      this.close.emit({ name: this.formControlText, value: "-1", methods: this.callbackMethods() });
    }
  }

  addEvent() {
    let thisobj = this;
    document.querySelectorAll("input[list]").forEach((hElement) => {
      hElement.addEventListener("input", function (e) {
        var input = e.target as HTMLTextAreaElement,
          listCopy = input.getAttribute("list"),
          options: any = Array.from(
            document.querySelectorAll("#" + listCopy + " option")
          ),
          hiddenInput = <HTMLInputElement>(
            document.getElementById(input.getAttribute("id") + "-hidden")
          ),
          label = input.value;

        hiddenInput.nodeValue = label;
        let find = thisobj.findOption(label);
        if (find) {
          hiddenInput.value = find[thisobj.dataInput];
          thisobj.editorRegistroForm
            .get("answerHidden")
            .setValue(find[thisobj.dataInput]);
        }
        // thisobj.closeInput();
        /* for(var i = 0; i < options.length; i++) {
            var option = options[i];
            option.innerHTML = option.innerHTML.trim()
            if(option.innerHTML == label) {
              hiddenInput.value = option.getAttribute('title');
                break;
            }
        } */
      });
    });
  }

  get f() {
    return this.editorRegistroForm.controls;
  }

  /** Evita `translation["..."]` no template (ngtypecheck / Angular 11). */
  get textoCampoRequerido(): string {
    const t = this.translation;
    return (
      (t && (t["CampoRequerido"] || t["CampoObligatorio"])) || "Campo requerido"
    );
  }

  /** Mensagem sob o campo (com ou sem autoValidate; validateTrigger marca touched). */
  get showCampoRequeridoMatError(): boolean {
    if (!this.isRequiredField) {
      return false;
    }
    const a = this.editorRegistroForm?.get("answer");
    return !!(a?.errors?.required && (a.touched || a.dirty));
  }

  /** Evita "*" no label: `required="false"` no template é string truthy. */
  get isRequiredField(): boolean {
    return this.required === true || this.required === "true";
  }

  get isParentSubmitLatchShowingExternally(): boolean {
    const latched =
      this.parentSubmitRequiredLatch === true ||
      this.parentSubmitRequiredLatch === "true";
    const suppressed =
      this.suppressParentSubmitLatch === true ||
      this.suppressParentSubmitLatch === "true";
    return latched && !suppressed;
  }

  get outlineInvalidFromParentLatch(): boolean {
    return this.isParentSubmitLatchShowingExternally;
  }

  selectString(str) {
    if (this.listCopy && this.listCopy.length > 0) {
      const valName = str ?? "";
      let val = this.editorRegistroForm.get("answerHidden").value;

      let find = this.listCopy.find(
        (row) =>
          this.normalizeInputFilterLabel(row[this.textShow]) ===
          this.normalizeInputFilterLabel(valName)
      );

      if (!find) {
        this.editorRegistroForm.controls["answerHidden"].setValue("");
        const answerVal = this.editorRegistroForm.controls["answer"]?.value;
        if (answerVal != null && String(answerVal).trim() !== "") {
          this.editorRegistroForm.controls["answer"].setErrors({
            incorrect: true,
          });
        }
        //this.editorRegistroForm.controls["answer"].updateValueAndValidity()
        //(<HTMLInputElement>document.getElementById(this.formControlText)).innerHTML=""
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.controls["answer"].setValue(
          find[this.textShow]
        );
        this.editorRegistroForm.get("answerHidden").setValue(valueFind);

        /*  if(this.editorRegistroForm.controls["answer"].value.trim()!=""){
          this.editorRegistroForm.controls["answer"].setErrors(null);
        } */
        this.editorRegistroForm.controls["answer"].setErrors(null);
        //this.editorRegistroForm.controls["answerHidden"].setValue(val);
        this.selected.emit(true);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.close.emit({ name: this.formControlText, value: val, methods: this.callbackMethods() });
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.close.emit({ name: this.formControlText, value: "-1", methods: this.callbackMethods() });
    }
  }

  findOption(label) {
    const labelStr = this.normalizeInputFilterLabel(label);
    let find = this.listCopy.find(
      (row) => this.normalizeInputFilterLabel(row[this.textShow]) === labelStr
    );

    return find;
  }
}
